import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import Page from '../../../components/Page/Page';
import { HomeProvider } from '../../context/homeContext';
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import s from './Legal.css';

class Legal extends React.Component {

  render() {
    const { getAllHomePageSettings: { loading, getAllHomePageSettings }, data: { getEditStaticPage, loading: staticLoading } } = this.props;
    const { currentLocale } = this.props;
    let homeSettings = {}, dynamicStaticContentSettings, content;
    if (!loading) {
      getAllHomePageSettings && getAllHomePageSettings.homePageData.map((item) => {
        homeSettings[item.name] = item.value
      })
    }

    dynamicStaticContentSettings = getDynamicTitleByLocale({ dynamicHomePageSettings: getEditStaticPage?.result?.dynamicStaticContentSettings, locale: currentLocale });

    content = dynamicStaticContentSettings[0]?.content || getEditStaticPage?.result?.content;

    const pageBanner = getEditStaticPage && getEditStaticPage.result.pageBanner

    return (
      <div>
        {!loading && !staticLoading &&
          <div>
            <HomeProvider value={homeSettings}>
              <div className={s.homeBanner} />
              <Page
                html={content}
                pageBanner={pageBanner}
              />
            </HomeProvider>
          </div>}
      </div>
    );
  }
}

const mapState = (state) => ({
  currentLocale: state?.intl?.locale
});

const mapDispatch = {
};

export default compose(
  withStyles(s),
  connect(mapState, mapDispatch),
  graphql(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: true
    }
  })
)(Legal);
